<div class="col1">
  <label>{{ label }}</label>
</div>
<div class="col2">
  <rr-badge
    size="Small"
    iconStart="check-circle"
    tone="success"
    *ngIf="status === KeyResultItemStatus.COMPLETED"
    >Completed</rr-badge
  >
  <rr-badge
    size="Small"
    iconStart="clock"
    tone="information"
    *ngIf="status === KeyResultItemStatus.INPROGRESS"
    >In Progress</rr-badge
  >
  <rr-badge
    size="Small"
    iconStart="locked"
    tone="neutral"
    *ngIf="status === KeyResultItemStatus.NOTAVAILABLE"
    >Not Yet Availlable</rr-badge
  >
  <rr-badge
    size="Small"
    iconStart="wrench"
    tone="warning"
    *ngIf="status === KeyResultItemStatus.COMINGSOON"
    >Coming Soon</rr-badge
  >
</div>
<div class="col3 end">
  <!-- <div *ngIf="value === undefined"></div> -->
  <rr-btn
    size="Small"
    type="Secondary"
    *ngIf="value === true"
    (click)="showClicked.emit()"
    >Show</rr-btn
  >
  <rr-btn
    size="Small"
    type="Link"
    *ngIf="value === false"
    (click)="createClicked.emit()"
    >Create</rr-btn
  >
</div>
